/**
 * A place to store common color constants.
 */
export const contentBackgroundColor = '#F1F3F9'